"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _reactInnertext = _interopRequireDefault(require("react-innertext"));
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
function _createForOfIteratorHelper(a, b) {
  var c = "undefined" != typeof Symbol && a[Symbol.iterator] || a["@@iterator"];
  if (!c) {
    if (Array.isArray(a) || (c = _unsupportedIterableToArray(a)) || b && a && "number" == typeof a.length) {
      c && (a = c);
      var d = 0,
        e = function e() {};
      return {
        s: e,
        n: function n() {
          return d >= a.length ? {
            done: !0
          } : {
            done: !1,
            value: a[d++]
          };
        },
        e: function e(a) {
          throw a;
        },
        f: e
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var f,
    g = !0,
    h = !1;
  return {
    s: function s() {
      c = c.call(a);
    },
    n: function n() {
      var a = c.next();
      return g = a.done, a;
    },
    e: function e(a) {
      h = !0, f = a;
    },
    f: function f() {
      try {
        g || null == c["return"] || c["return"]();
      } finally {
        if (h) throw f;
      }
    }
  };
}
function _unsupportedIterableToArray(a, b) {
  if (a) {
    if ("string" == typeof a) return _arrayLikeToArray(a, b);
    var c = Object.prototype.toString.call(a).slice(8, -1);
    return "Object" === c && a.constructor && (c = a.constructor.name), "Map" === c || "Set" === c ? Array.from(a) : "Arguments" === c || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? _arrayLikeToArray(a, b) : void 0;
  }
}
function _arrayLikeToArray(a, b) {
  (null == b || b > a.length) && (b = a.length);
  for (var c = 0, d = Array(b); c < b; c++) d[c] = a[c];
  return d;
}
var _default = function _default(a) {
  for (var b = [], c = 0; c < a.length; c++) {
    var d,
      e = a[c],
      f = e.message,
      g = e.isEcho,
      h = (0, _reactInnertext["default"])(f),
      j = !g && /\n|\\n/g.test(h) ? h.split(/\n|\\n/g) : [f],
      k = _createForOfIteratorHelper(j);
    try {
      for (k.s(); !(d = k.n()).done;) {
        var l = d.value;
        b.push({
          message: l,
          isEcho: e.isEcho
        });
      }
    } catch (a) {
      k.e(a);
    } finally {
      k.f();
    }
  }
  return b;
};
exports["default"] = _default;